$shm_hitalama_profile_enter $shm_hitalama_profile_register
	title \Вход
	submit_title \Войти
	auto / <= pull_pass_keys null
	message_incorrect_pass \Неверный логин или пароль
